import ACTIONS, { FETCH_STATUS } from "../constants";

export const getClientsAttempt = {
  pending: {
    type: ACTIONS.CLIENTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CLIENTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CLIENTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getClients = (state) => ({
  type: ACTIONS.CLIENTS_CALL,
  payload: state,
});

export const sortClientAttempt = {
  pending: {
    type: ACTIONS.SORT_CLIENTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_CLIENTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_CLIENTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortClientRequest = (state) => ({
  type: ACTIONS.SORT_CLIENTS_CALL,
  payload: state,
});

export const createClientAttempt = {
  pending: {
    type: ACTIONS.CREATE_CLIENT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_CLIENT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_CLIENT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createClientRequest = (state) => ({
  type: ACTIONS.CREATE_CLIENT_CALL,
  payload: state,
});

export const updateClientAttempt = {
  pending: {
    type: ACTIONS.UPDATE_CLIENT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_CLIENT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_CLIENT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateClientRequest = (state) => ({
  type: ACTIONS.UPDATE_CLIENT_CALL,
  payload: state,
});

export const deleteClientAttempt = {
  pending: {
    type: ACTIONS.DELETE_CLIENT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_CLIENT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_CLIENT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteClientRequest = (state) => ({
  type: ACTIONS.DELETE_CLIENT_CALL,
  payload: state,
});

export const getClientDetailsAttempt = {
  pending: {
    type: ACTIONS.GET_CLIENT_DETAILS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_CLIENT_DETAILS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_CLIENT_DETAILS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getClientDetails = (state) => ({
  type: ACTIONS.GET_CLIENT_DETAILS_CALL,
  payload: state,
});

export const updateClientFlagAttempt = {
  pending: {
    type: ACTIONS.CLIENT_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CLIENT_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CLIENT_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateClientFlag = (state) => ({
  type: ACTIONS.CLIENT_FLAG_CALL,
  payload: state,
});

////////////////////////////////////////////////// PORTFOLIOS //////////////////////////////////////////////////  

export const getPortfoliosAttempt = {
  pending: {
    type: ACTIONS.CLIENT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CLIENT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CLIENT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPortfolios = (state) => ({
  type: ACTIONS.CLIENT_PORTFOLIOS_CALL,
  payload: state,
});

export const sortPortfoliosAttempt = {
  pending: {
    type: ACTIONS.SORT_CLIENT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_CLIENT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_CLIENT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortPortfoliosRequest = (state) => ({
  type: ACTIONS.SORT_CLIENT_PORTFOLIOS_CALL,
  payload: state,
});

export const createPortfolioAttempt = {
  pending: {
    type: ACTIONS.CREATE_CLIENT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_CLIENT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_CLIENT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createPortfolioRequest = (state) => ({
  type: ACTIONS.CREATE_CLIENT_PORTFOLIOS_CALL,
  payload: state,
});

export const updatePortfolioAttempt = {
  pending: {
    type: ACTIONS.UPDATE_CLIENT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_CLIENT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_CLIENT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updatePortfolioRequest = (state) => ({
  type: ACTIONS.UPDATE_CLIENT_PORTFOLIOS_CALL,
  payload: state,
});

export const deletePortfolioAttempt = {
  pending: {
    type: ACTIONS.DELETE_CLIENT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_CLIENT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_CLIENT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deletePortfoliosRequest = (state) => ({
  type: ACTIONS.DELETE_CLIENT_PORTFOLIOS_CALL,
  payload: state,
});


////////////////////////////////////////////////// ALLOCATED RESOURCES //////////////////////////////////////////////////  

export const getClientResourcesRequest = (state) => ({
  type: ACTIONS.CLIENT_RESOURCES_CALL,
  payload: state,
});

export const getClientResourcesAttempt = {
  pending: {
    type: ACTIONS.CLIENT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CLIENT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CLIENT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortClientResourcesAttempt = {
  pending: {
    type: ACTIONS.SORT_CLIENT_RESOURCES.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_CLIENT_RESOURCES.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_CLIENT_RESOURCES.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortClientResourcesRequest = (state) => ({
  type: ACTIONS.SORT_CLIENT_RESOURCES_CALL,
  payload: state,
});
